import { connect } from 'react-redux';

const mapStateToProps = ({ TrackerData: { currentTracker } }) => {
  const trackerCanBeShown = !currentTracker.loading && currentTracker.simiccid;
  return { currentTracker, trackerCanBeShown };
};

export default (WrappedComponent) => connect(mapStateToProps, null)(WrappedComponent);
